import * as React from 'react';
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 31.092 22.666"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.126 5.869a1.13 1.13 0 0 0-1.133-.015 1.12 1.12 0 0 0-.571.979v9a1.13 1.13 0 0 0 .571.979 1.12 1.12 0 0 0 1.133-.014l7.5-4.5a1.13 1.13 0 0 0 .546-.965 1.13 1.13 0 0 0-.546-.964zm4.734 5.464-4.188 2.513V8.821z"
    />
    <path
      fill="currentColor"
      d="M23.092.295a97 97 0 0 0-15.09 0L4.64.559A4.46 4.46 0 0 0 .586 4.271a42.9 42.9 0 0 0 0 14.124 4.464 4.464 0 0 0 4.054 3.713l3.36.264c5.024.393 10.07.393 15.093 0l3.36-.264a4.47 4.47 0 0 0 4.055-3.713c.78-4.675.78-9.448 0-14.124A4.46 4.46 0 0 0 26.453.559zM8.177 2.539a94.5 94.5 0 0 1 14.742 0l3.36.262c1.014.08 1.844.84 2.01 1.842a40.5 40.5 0 0 1 0 13.38 2.21 2.21 0 0 1-2.01 1.842l-3.36.263a94.5 94.5 0 0 1-14.742 0l-3.36-.263a2.21 2.21 0 0 1-2.01-1.842 40.5 40.5 0 0 1 0-13.38 2.215 2.215 0 0 1 2.01-1.842z"
    />
  </svg>
);
export default SvgComponent;
